module.exports = __webpack_public_path__ + "static/media/rate-star.83531b61.svg";